import { motion } from "framer-motion";
import { LayoutGrid, Zap, MessageSquare, LineChart } from "lucide-react";

const solutions = [
  {
    icon: LayoutGrid,
    title: "Centralized Management Administration",
    desc: "Manage students, teachers, classes, and academic records from one platform.",
  },
  {
    icon: Zap,
    title: "Automated School Operations",
    desc: "Reduce manual work by automating attendance, reporting, and administrative tasks.",
  },
  {
    icon: MessageSquare,
    title: "Improved Communication",
    desc: "Enable smooth communication between teachers, students, parents, and school management.",
  },
  {
    icon: LineChart,
    title: "Real-Time Data & Reports",
    desc: "Access real-time insights and reports to make better academic and administrative decisions.",
  },
];

const SolutionsSection = () => (
  <section className="py-24 bg-slate-50 dark:bg-slate-900">
    <div className="container mx-auto px-4 lg:px-8 max-w-6xl">
      <div className="text-center mb-16 max-w-3xl mx-auto">
        <span className="inline-block px-4 py-1.5 rounded-full bg-primary/10 text-primary text-xs font-bold uppercase tracking-wider mb-6">
          SOLUTIONS
        </span>
        <h2 className="text-3xl md:text-5xl font-heading font-bold text-slate-800 dark:text-slate-100 mb-6 tracking-tight">
          A Smarter Way to Manage Your School
        </h2>
        <p className="text-lg text-slate-500 dark:text-slate-400 font-medium leading-relaxed max-w-2xl mx-auto">
          Our school management platform brings all school operations into one centralized system, helping administrators, teachers, and staff manage daily activities more efficiently.
        </p>
      </div>

      <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
        {solutions.map((s, i) => (
          <motion.div
            key={i}
            className="flex flex-col gap-4 p-6 rounded-2xl bg-white dark:bg-slate-950 border border-slate-100 dark:border-slate-800 hover:shadow-lg transition-all hover:border-primary/20 group"
          >
            <div className="w-12 h-12 rounded-xl bg-primary/10 flex items-center justify-center text-primary group-hover:bg-primary/20 transition-colors">
              <s.icon className="w-6 h-6" />
            </div>
            <div>
              <h3 className="font-bold text-slate-800 dark:text-slate-200 mb-2 leading-snug">{s.title}</h3>
              <p className="text-slate-500 dark:text-slate-400 text-sm leading-relaxed">{s.desc}</p>
            </div>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);

export default SolutionsSection;
